import whiteArrow from "../../../img/white-arrow.png";

export { Triangle };

const Triangle = () => {
  return (
    <div className={"actionBarItem img triangle disabled"}>
      <img src={whiteArrow} />
    </div>
  );
};
